<template>
  <section>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Edit Evaluation Note</p>
      </header>
      <section class="modal-card-body">
        <vue-editor
          :editorToolbar="customToolbar"
          v-model="$store.state.evaluation.notes"
        ></vue-editor>
      </section>
      <footer class="modal-card-foot">
        <button
          class="button"
          type="button"
          @click="() => { cancel(); $parent.close() }"
        >Cancel</button>
        <button
          class="button is-primary"
          @click="() => { saveNote(); $parent.close() }"
        >Save</button>
      </footer>
    </div>
  </section>
</template>

<script>
import store from "@/store";
import Helpers from "@/services/Helpers.js";
import { VueEditor } from "vue2-editor";

export default {
  components: {
    store,
    Helpers,
    VueEditor
  },

  data() {
    return {
      originalNotes: "",
      customToolbar: [["bold", "italic", "underline"]]
    };
  },

  mounted() {
    console.log(
      "mounted() the notes are = ",
      this.$store.state.evaluation.notes
    );
    this.originalNotes = this.$store.state.evaluation.notes;
  },

  methods: {
    saveNote() {
      var propertyId = store.state.evaluation.propertyId;
      var evaluationId = store.state.evaluation.id;
      var notes = store.state.evaluation.notes;
      store.dispatch("updateEvaluationNotes", {
        propertyId,
        evaluationId,
        notes
      });
    },

    cancel() {
      this.$store.state.evaluation.notes = this.originalNotes;
    }
  }
};
</script>

<style>
</style>
